import template from './has-drainage.jade';

export default angular
    .module('cian.addForm.hasDrainage', [])
    .directive('cianAfAboutObjectHasDrainage', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller(deviceService) {
            'ngInject';

            this.isMobile = deviceService.isMobile;

            this.items = [{
                text: 'Есть',
                value: true,
            }, {
                text: 'Нет',
                value: false,
            }];
        },
        controllerAs: 'hasDrainage',
        template,
    }))
    .name;
